const capabilities = [
  {
    legacy: "Portfolio",
    href: "/programs?view=portfolio",
    target: "Programs / portfolio",
    authority: "Governed Workbench"
  },
  {
    legacy: "Board",
    href: "/execution-plans?view=board",
    target: "Execution board",
    authority: "Governed execution planning"
  },
  {
    legacy: "Workspace",
    href: "/execution-plans?view=workspaces",
    target: "Object / execution workspaces",
    authority: "Governed Workbench"
  },
  {
    legacy: "Evidence",
    href: "/evidence",
    target: "Evidence",
    authority: "Immutable evidence"
  },
  {
    legacy: "Approvals",
    href: "/approvals",
    target: "Approvals",
    authority: "Exact named-human gate"
  },
  {
    legacy: "Audit",
    href: "/audit",
    target: "Audit",
    authority: "Governed audit"
  },
  {
    legacy: "Workers",
    href: "/workers",
    target: "AI workforce",
    authority: "Worker registry / runtime"
  },
  {
    legacy: "Metrics",
    href: "/operations?view=metrics",
    target: "Operations / metrics",
    authority: "Operational control plane"
  },
  {
    legacy: "GitLab",
    href: "/operations?view=gitlab",
    target: "Operations / GitLab",
    authority: "Least-privilege integration"
  }
] as const;

export function CockpitConvergencePanel() {
  return (
    <section
      className="cockpit-convergence-panel"
      aria-labelledby="cockpit-convergence-heading"
    >
      <header>
        <div>
          <p className="eyebrow">Single Software Factory</p>
          <h2 id="cockpit-convergence-heading">
            Cockpit capabilities are preserved here
          </h2>
          <p>
            Cockpit navigation is converging into the governed Software Factory
            without importing duplicate authority or creating a second product.
          </p>
        </div>
        <span className="status-pattern status-positive">
          <span aria-hidden="true">✓</span>
          CONVERGENCE ACTIVE
        </span>
      </header>

      <div className="cockpit-convergence-grid">
        {capabilities.map(capability => (
          <a
            className="cockpit-capability-link"
            href={capability.href}
            key={capability.legacy}
          >
            <span>{capability.legacy}</span>
            <strong>{capability.target}</strong>
            <small>{capability.authority}</small>
          </a>
        ))}
      </div>

      <aside className="cockpit-convergence-note" role="note">
        <strong>Product Registry remains governed work.</strong>
        <span>
          The Products route is preserved, but live Product Registry authority
          will be delivered through SF-201.1 rather than substituted with
          Cockpit fixtures or static product cards.
        </span>
      </aside>
    </section>
  );
}
